import { render } from "./ProvideFeatureDecisions.vue?vue&type=template&id=63025f26&ts=true"
import script from "./ProvideFeatureDecisions.vue?vue&type=script&lang=ts"
export * from "./ProvideFeatureDecisions.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__